import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * A simple breadcrumb nav for league sub-pages.
 *
 * @param {{ items: Array<{ label: string, to?: string }> }} props
 *   Each item has a label; the last item has no `to` (it's the current page).
 */
const Breadcrumb = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" className="mb-2">
      <ol className="flex items-center gap-1 text-xs font-sans font-semibold text-white/50">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="w-3 h-3 shrink-0" aria-hidden="true" />}
            {item.to ? (
              <Link
                to={item.to}
                className="hover:text-mustard transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-white/80" aria-current="page">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
